import { identityOrigin, object } from './protocol';

export type WechatBindingPresentation = Readonly<{
  revision: 1;
  purpose: 'binding';
  connectorId: string;
}>;

/** Native SSR display data only. Query, navigation and storage never select it. */
export function getWechatBindingPresentation(
  ssr: unknown = window.logtoSsr
): WechatBindingPresentation | undefined {
  if (window.location.origin !== identityOrigin || !object(ssr)) {
    return;
  }
  const value = ssr.vibehubWechatBinding;
  if (
    !object(value) ||
    Object.keys(value).slice().sort().join(',') !== 'connectorId,purpose,revision' ||
    value.revision !== 1 ||
    value.purpose !== 'binding' ||
    typeof value.connectorId !== 'string' ||
    !/^[A-Za-z0-9_-]{1,64}$/u.test(value.connectorId)
  ) {
    return;
  }
  return { revision: 1, purpose: 'binding', connectorId: value.connectorId };
}
